<template>
  <v-container class="py-0 px-0" fluid tag="section">
    <base-material-table flat :item="item" ref="table"></base-material-table>
  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'

  export default {
    name: 'PatentRecordCost',
    components: {
    },
    data() {
      return {
        detailModal: { show: false, data: {} },
        item: {
          mobile: true,
          path: 'patent/cost/list',
          topButtons: [
            { event: 'search', show: true }
          ],
           params: {
          },
          headers: [
            {
              text: '企业名称',
              align: 'center',
              divider: true,
              value: 'patent.customerName',
              sortable: false,
              copy: true,
              width: 200,
              mobile: true,
              search: { type: 'input', secKey: 'customerName', mobile: true },
              formatter: (val, item) => val || item.customer
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              value: 'contract.serialNumber',
              sortable: false,
              copy: true,
              width: 200,
              search: { type: 'input' },
              formatter: (val) => val || '--'
            },
            {
              text: '专利名称',
              align: 'center',
              divider: true,
              copy: true,
              value: 'patent.name',
              sortable: false,
              width: 220,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '专利编号',
              align: 'center',
              divider: true,
              value: 'patent.patentCode',
              sortable: false,
              copy: true,
              width: 170,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', secKey: 'patentCode', mobile: true }
            },
            {
              text: '专利类型',
              align: 'center',
              divider: true,
              value: 'patent.patentType',
              sortable: false,
              width: 120,
              mobile: true,
              chip: {
                color: (val) => (val === 1 ? 'success' : val === 2 ? 'cyan' : 'blue'),
                formatter: (val) => (val === 1 ? '实用新型' : val === 2 ? '发明专利' : '外观专利')
              }
            },
            {
              text: '年份',
              align: 'center',
              divider: true,
              value: 'year',
              sortable: false,
              width: 120,
              mobile: true,
              search: {
                type: 'select',
                name: 'year',
                options: () => selectData2()
              }
            },
            {
              text: '缴费金额',
              align: 'center',
              divider: true,
              value: 'annualFee',
              sortable: false,
              width: 120,
              mobile: true,
            },
            {
              text: '其他费用',
              align: 'center',
              divider: true,
              value: 'otherFee',
              sortable: false,
              mobile: true,
              width: 120
            },
            {
              text: '缴费人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              sortable: false,
              mobile: true,
              width: 120
            },
            {
              text: '受理时间',
              align: 'center',
              divider: true,
              value: 'patent.acceptTime',
              sortable: true,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD'),
              width: 140
            },
            {
              text: '授权时间',
              align: 'center',
              divider: true,
              value: 'patent.authTime',
              sortable: true,
              mobile: true,
              formatter: (val) => (val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--'),
              width: 140
            },
            {
              text: '备注信息',
              align: 'center',
              value: 'remark',
              sortable: true,
              mobile: true,
              formatter: (val) => val || '--',
              width: 250
            },
            {
              text: '缴费时间',
              align: 'center',
              divider: true,
              value: 'createTime',
              sortable: false,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD'),
              width: 130
            },
          ]
        }
      }
    },
    methods: {
      detail (item) {
        this.detailModal = { show: true, data: item }
      },
      loadCostData () {
        this.$refs.costTable.loadData()
      }
    }
  }
</script>

<style lang="sass">
</style>
